import React, { useContext, useEffect, useState } from 'react'
import NavBar from './bar'
import NavOverlay from './overlay'
import NavMobile from './mobile'
import AppContext from 'context/app'

export default function Nav({ zIndex }) {
    const { overlay, setOverlay } = useContext(AppContext)
    const [position, setPosition] = useState('sticky')

    const handlePosition = () => {
        if (typeof document === 'undefined') return
        const subnav = document.querySelector('#page-subnavigation-bar')
        subnav && !overlay ? setPosition('relative') : setPosition('sticky')
    }

    useEffect(() => {
        handlePosition()
        
        const handleNavigate = () => {
            setOverlay('')
            handlePosition()
        }

        window.addEventListener('navigate', handleNavigate)
        return () => window.removeEventListener('navigate', handleNavigate)
    }, [])

    useEffect(() => handlePosition(), [overlay])

    return <nav id='nav' style={{ position, zIndex }}>
        <NavBar />
        <NavOverlay />
        <NavMobile />
    </nav>
}
